const isProduction = process.env.NODE_ENV === 'production'
const EnvironmentName = process.env.VUE_APP_EnvironmentName
let MQ_USERNAME = ''
let MQ_PASSWORD = ''
let EXCHANGE_NAME = ''
let WS_ADDRESS = ''
let MQ_HOST = ''
switch (EnvironmentName) {
  case 'prod':
    MQ_USERNAME = isProduction ? 'wisdompark_v2_saas' : 'wisdompark_v2_saas'
    MQ_PASSWORD = isProduction ? 'Glasssix+1S' : 'Glasssix+1S'
    EXCHANGE_NAME = isProduction ? '/exchange/wisdompark_v2_saas/pushDeviceLog' : '/exchange/wisdompark_v2_saas/pushDeviceLog'
    WS_ADDRESS = isProduction ? 'wss://r.zelo.facebeacon.com/wss' : 'wss://r.zelo.facebeacon.com/wss'
    MQ_HOST = isProduction ? 'wisdompark_v2_saas' : 'wisdompark_v2_saas'
    break
  case 'dev':
    MQ_USERNAME = isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2'
    MQ_PASSWORD = isProduction ? 'Glasssix+1S' : 'Glasssix+1S'
    EXCHANGE_NAME = isProduction ? '/exchange/wisdompark_test_v2/pushDeviceLog' : '/exchange/wisdompark_test_v2/pushDeviceLog'
    WS_ADDRESS = isProduction ? `ws://10.168.1.47:32537/ws` : 'ws://10.168.1.47:32537/ws'
    MQ_HOST = isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2'
    break
  case 'test':
    MQ_USERNAME = isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2'
    MQ_PASSWORD = isProduction ? 'Glasssix+1S' : 'Glasssix+1S'
    EXCHANGE_NAME = isProduction ? '/exchange/wisdompark_test_v2/pushDeviceLog' : '/exchange/wisdompark_test_v2/pushDeviceLog'
    WS_ADDRESS = isProduction ? `ws://192.168.16.9:30240/ws` : 'ws://192.168.16.9:30240/ws'
    MQ_HOST = isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2'
    break
  case 'pre':
    MQ_USERNAME = isProduction ? 'wisdompark_v2_prerelease' : 'wisdompark_v2_prerelease'
    MQ_PASSWORD = isProduction ? 'Glasssix+1S' : 'Glasssix+1S'
    EXCHANGE_NAME = isProduction ? '/exchange/wisdompark_v2_prerelease/pushDeviceLog' : '/exchange/wisdompark_v2_prerelease/pushDeviceLog'
    WS_ADDRESS = isProduction ? ' ws://124.70.19.194:31812/ws' : ' ws://124.70.19.194:31812/ws'
    MQ_HOST = isProduction ? 'wisdompark_v2_prerelease' : 'wisdompark_v2_prerelease'
    break
  default:
}
module.exports = {
  MQ_USERNAME: MQ_USERNAME, // sokcet连接username
  MQ_PASSWORD: MQ_PASSWORD, // socket连接password
  EXCHANGE_NAME: EXCHANGE_NAME, // 监听key-订阅的目的地
  WS_ADDRESS: WS_ADDRESS, // socket连接地址
  MQ_HOST: MQ_HOST
}
// const isProduction = process.env.NODE_ENV === 'production'
// // 测试版本
// // module.exports = {
// //   MQ_USERNAME: isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2',
// //   MQ_PASSWORD: isProduction ? 'Glasssix+1S' : 'Glasssix+1S', // socket连接password
// //   EXCHANGE_NAME: isProduction ? '/exchange/wisdompark_test_v2/pushDeviceLog' : '/exchange/wisdompark_test_v2/pushDeviceLog', // 监听key-订阅的目的地
// //   WS_ADDRESS: isProduction ? `ws://10.168.1.47:32537/ws` : 'ws://10.168.1.47:32537/ws', // socket连接地址
// //   MQ_HOST: isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2'
// // }

// // 正式环境--运维端
// // module.exports = {
// //   MQ_USERNAME: isProduction ? 'wisdompark_v2_saas' : 'wisdompark_v2_saas',
// //   MQ_PASSWORD: isProduction ? 'Glasssix+1S' : 'Glasssix+1S', // socket连接password
// //   EXCHANGE_NAME: isProduction ? '/exchange/wisdompark_v2_saas/pushDeviceLog' : '/exchange/wisdompark_v2_saas/pushDeviceLog', // 监听key
// //   WS_ADDRESS: isProduction ? 'wss://r.zelo.facebeacon.com/wss' : 'wss://r.zelo.facebeacon.com/wss', // socket连接地址
// //   MQ_HOST: isProduction ? 'wisdompark_v2_saas' : 'wisdompark_v2_saas'
// // }

// // 预发布环境--运维端
// // module.exports = {
// //   MQ_USERNAME: isProduction ? 'wisdompark_v2_prerelease' : 'wisdompark_v2_prerelease',
// //   MQ_PASSWORD: isProduction ? 'Glasssix+1S' : 'Glasssix+1S', // socket连接password
// //   EXCHANGE_NAME: isProduction ? '/exchange/wisdompark_v2_prerelease/receive' : '/exchange/wisdompark_v2_prerelease/receive', // 监听key
// //   WS_ADDRESS: isProduction ? ' ws://124.70.19.194:31812/ws' : ' ws://124.70.19.194:31812/ws', // socket连接地址
// //   MQ_HOST: isProduction ? 'wisdompark_v2_prerelease' : 'wisdompark_v2_prerelease'
// // }

// // 开发环境--运维端
// module.exports = {
//   MQ_USERNAME: isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2',
//   MQ_PASSWORD: isProduction ? 'Glasssix+1S' : 'Glasssix+1S', // socket连接password
//   EXCHANGE_NAME: isProduction ? '/exchange/wisdompark_test_v2/pushDeviceLog' : '/exchange/wisdompark_test_v2/pushDeviceLog', // 监听key-订阅的目的地
//   WS_ADDRESS: isProduction ? `ws://10.168.1.47:32537/ws` : 'ws://10.168.1.47:32537/ws', // socket连接地址
//   MQ_HOST: isProduction ? 'wisdompark_test_v2' : 'wisdompark_test_v2'
// }
